module.exports = __webpack_public_path__ + "static/media/49@2x.53f1752f.png";